import { render, staticRenderFns } from "./EinstellungenGeschaeftspartner.vue?vue&type=template&id=722423ba&"
import script from "./EinstellungenGeschaeftspartner.vue?vue&type=script&lang=js&"
export * from "./EinstellungenGeschaeftspartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports